import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDevToken(data.dev_token);
      setSent(true);
    } catch (e2) { errMsg(e2); setSent(true); }
    finally { setLoading(false); }
  };

  return (
    <div className="sea-bg flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <div className="glass rounded-2xl p-8 shadow-2xl">
          {!sent ? (
            <form onSubmit={submit} data-testid="forgot-form">
              <p className="label-eyebrow">Account Recovery</p>
              <h2 className="mt-1 font-display text-3xl font-700">Reset Password</h2>
              <p className="mt-1 text-sm text-muted-foreground">We'll send a secure, single-use reset link.</p>
              <div className="mt-6">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@baniupsilongalleon.org" className="mt-1.5" data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="mt-6 w-full bg-[hsl(var(--gold))] font-700 text-[#0A192F]" data-testid="forgot-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
              </Button>
            </form>
          ) : (
            <div className="text-center" data-testid="forgot-confirmation">
              <MailCheck className="mx-auto h-12 w-12 text-[hsl(var(--water))]" />
              <h2 className="mt-3 font-display text-2xl font-700">Check Your Inbox</h2>
              <p className="mt-2 text-sm text-muted-foreground">
                If that email is registered, a reset link has been sent.
              </p>
              {devToken && (
                <div className="mt-4 rounded-lg border border-[hsl(var(--gold))]/40 bg-[hsl(var(--gold))]/10 p-3 text-left text-xs">
                  <p className="font-700 text-[hsl(var(--gold))]">Email is disabled on this build.</p>
                  <p className="mt-1 text-muted-foreground">Use this link to reset now:</p>
                  <Link to={`/reset-password?token=${devToken}`} className="mt-1 block break-all font-mono-data text-[hsl(var(--water))] hover:underline" data-testid="dev-reset-link">
                    /reset-password?token={devToken.slice(0, 16)}…
                  </Link>
                </div>
              )}
            </div>
          )}
          <div className="mt-6 text-center">
            <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
